import { render, staticRenderFns } from "./NavMedCenter.vue?vue&type=template&id=568c0edf&"
import script from "./NavMedCenter.vue?vue&type=script&lang=js&"
export * from "./NavMedCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports